import {Icon} from '@chakra-ui/react';

export const ChatIcon: React.FC<{
  color?: string;
  width?: string;
  height?: string;
}> = ({color = 'white', width = '14px', height = '14px'}) => {
  return (
    <Icon
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.66667 8H8V6.66667H2.66667V8ZM2.66667 6H10.6667V4.66667H2.66667V6ZM2.66667 4H10.6667V2.66667H2.66667V4ZM0 13.3333V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H12C12.3667 0 12.6806 0.130556 12.9417 0.391667C13.2028 0.652778 13.3333 0.966667 13.3333 1.33333V9.33333C13.3333 9.7 13.2028 10.0139 12.9417 10.275C12.6806 10.5361 12.3667 10.6667 12 10.6667H2.66667L0 13.3333ZM2.1 9.33333H12V1.33333H1.33333V10.0833L2.1 9.33333Z'
        fill='currentColor'
      />
    </Icon>
  );
};
